export default __webpack_public_path__ + "static/media/company_profile_download.a4382acc.svg";